class ProductSubscriptions extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[name="selling_plan"]')
    this.options = this.querySelectorAll('input[name="purchase_option"]')
    this.select = this.querySelector('select[name="purchase_option_values"]')

    this.initialise()
  }

  initialise() {
    this.options.forEach((option) =>
      option.addEventListener('click', this.onRadioChange.bind(this))
    )
    this.select.addEventListener('change', this.onSelectChange.bind(this))
  }

  onRadioChange(e) {
    this.input.value = e.target.value;
  }
  
  getCurrentSellingPlanId() {
    return this.input.value;
  }
}

if (!customElements.get('product-subscriptions')) {
  customElements.define('product-subscriptions', ProductSubscriptions)
}

window.ProductSubscriptions = ProductSubscriptions;

window.getCurrentSellingPlanId = function()
{
    const productSubscriptions = document.querySelector('product-subscriptions');
    if ( productSubscriptions )
    {
        console.log(productSubscriptions);
        return productSubscriptions ? productSubscriptions.getCurrentSellingPlanId() : '';
    }
    else
    {
        // this should be in the recharge code, but since the theme overrides the standard add to cart behaviour it's less risky to add the logic here
        var spid    = '';
        var rcPlans = document.querySelector( ".rc-radio--active.subscription-radio .rc-selling-plans select[name='rc_selling_plan']" );
        
        if ( ( rcPlans ) && ( rcPlans.selectedIndex >= 0 ) )
        {
            spid = rcPlans.options[ rcPlans.selectedIndex ].value;
        }

        return ( spid );
    }
};